export default "__VITE_ASSET__U4Km4E2___"